<template>
    <div id="approval-information" class="approval-information-wrapper scroll-mt- mt-8" v-if="submission.submission.submitted_at">
        <h2 class="text-xl mb-6">Approval Information</h2>
        <div class="flex flex-col md:flex-row md:items-center gap-4">
            <DownloadPillComponent label="W8BEN PDF" :filename="w8benFileName" :loading="!!isLoadingW8BEN" @click="doDownloadW8BEN" />
            <DownloadPillComponent v-if="documents.gbg_report.file_name" label="GBG Report" :filename="documents.gbg_report.file_name" :loading="!!isLoadingGbgReport" @click="doDownloadGbgReport" />
            <DownloadPillComponent label="CSV of Application" :filename="csvExportFilename" :loading="!!isLoadingCsvExport" @click="doDownloadApplicationCsv" />
        </div>
        <div class="px-8">
            <h4 class="mt-6">Additional Observations/Notes</h4>
            <div class="text-base mt-3">
                {{ submission.submission.notes ? submission.submission.notes : "N/A"  }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import DownloadPillComponent from '@adminComponents/buttons/DownloadPillComponent';

export default {
    name: "ApprovalInformationComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        DownloadPillComponent
    },
    computed: {
        ...mapGetters(["submission", "documents"]),
        w8benFileName(){
            let filename = this.submission.personal_details.first_name + "-" + this.submission.personal_details.last_name + "-w8ben.pdf";
            return filename.toLowerCase();
        },
        csvExportFilename(){
            let filename = this.submission.personal_details.first_name + "-" + this.submission.personal_details.last_name + "-applicant-details.csv";
            return filename.toLowerCase();
        }
    },
    data: function () {
        return {
            isLoadingW8BEN: false,
            isLoadingCsvExport: false,
            isLoadingGbgReport: false
        };
    },
    methods: {
        ...mapActions(["doGenerateW8BENAdminUrl", "doGenerateCsvExportUrl", "doGetSubmissionGbgReportDocument"]),
        doDownloadW8BEN(){
            this.isLoadingW8BEN = true;
            this.doGenerateW8BENAdminUrl(this.$route.params.user).then((response) => {
                let downloadUrl = response.file_url;
                window.open(downloadUrl, "_blank");
                this.isLoadingW8BEN = false;
            });
        },
        doDownloadApplicationCsv(){
            this.isLoadingCsvExport = true;
            this.doGenerateCsvExportUrl(this.$route.params.user).then((response) => {
                let downloadUrl = response.file_url;
                window.open(downloadUrl, "_blank");
                this.isLoadingCsvExport = false;
            });
        },
        doDownloadGbgReport(){
            this.isLoadingGbgReport = true;
            this.doGetSubmissionGbgReportDocument(this.$route.params.user).then((response) => {
                let downloadUrl = response.file_url;
                window.open(downloadUrl, "_blank");
                this.isLoadingGbgReport = false;
            });
        }
    },
};
</script>
